export default "__VITE_ASSET__B$bJ45h3__"